import { useState, useEffect } from "react";

import Button from "components/Button/Button";
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/modal";
import { List, ListItem, Stack, Text, HStack } from "@chakra-ui/layout";
import { IconButton } from "@chakra-ui/button";
import { CopyIcon } from "@chakra-ui/icons";

import capitalize from "lodash/capitalize";
// import formatter from "util/formatter";
import toPrecision from "util/toPrecision";
import { format, parseISO } from "date-fns";
import useCopy from "hooks/useCopy";

const ForStep1 = ({ type, amount, currency, description, createdAt, txId }) => {
  const { onCopy } = useCopy(txId);
  return (
    <Stack>
      <List>
        <ListItem>
          <HStack>
            <Text color="#4E4B66" fontSize="sm">
              Transaction Type:
            </Text>
            <Text color="#14142B" fontSize="sm">
              {capitalize(type)}
            </Text>
          </HStack>
        </ListItem>
        <ListItem mt="20px">
          <HStack>
            <Text color="#4E4B66" fontSize="sm">
              Amount:
            </Text>

            <Text color="#14142B" fontSize="sm">
              {/* {formatter(currency).format(amount)} */}
              {toPrecision(amount, currency)}
            </Text>
          </HStack>
        </ListItem>
        <ListItem mt="20px">
          <HStack alignItems="flex-start">
            <Text color="#4E4B66" fontSize="sm">
              Description:
            </Text>

            <Text color="#14142B" fontSize="sm">
              {description}
            </Text>
          </HStack>
        </ListItem>
        {txId && (
          <ListItem mt="20px">
            <HStack alignItems="flex-start">
              <Text color="#4E4B66" fontSize="sm">
                Transaction ID:
              </Text>

              <HStack mt="-2px !important">
                <Text color="#14142B" fontSize="sm">
                  {txId}
                </Text>

                <IconButton
                  size="xs"
                  variant="ghost"
                  aria-label="copy"
                  icon={<CopyIcon />}
                  onClick={onCopy}
                  _focus={{ shadow: "0 0 0 3px var(--focusColor)" }}
                />
              </HStack>
            </HStack>
          </ListItem>
        )}

        <ListItem mt="20px">
          <HStack>
            <Text color="#4E4B66" fontSize="sm">
              CreatedAt:
            </Text>

            <Text color="#14142B" fontSize="sm">
              {format(parseISO(createdAt), "eee, dd MMM yyyy, HH:mm")}
            </Text>
          </HStack>
        </ListItem>
      </List>
    </Stack>
  );
};

const CardTransactionDetail = ({
  isOpen,
  onClose,
  isLoading,
  title,
  type,
  amount,
  currency,
  description,
  createdAt,
  txId,
}) => {
  const [currentStep, setCurrentStep] = useState(0);
  //   const maxStep = 1;

  const previewMap = (step) => {
    const map = {
      0: (
        <ForStep1
          type={type}
          amount={amount}
          currency={currency}
          description={description}
          createdAt={createdAt}
          txId={txId}
        />
      ),
    };

    return map[step];
  };

  useEffect(() => setCurrentStep(0), [isOpen]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent bg="#F8F9FD" overflow="hidden" borderRadius="16px">
        <ModalHeader p="26px 0" textAlign="center" bg="white" fontSize="md">
          <Text
            textAlign="center"
            maxW="50%"
            whiteSpace="nowrap"
            overflow="hidden"
            textOverflow="ellipsis"
            m="0 auto"
          >
            {title}
          </Text>
        </ModalHeader>
        <ModalCloseButton
          top="23px"
          right="20px"
          _focus={{ shadow: "0 0 0 3px var(--focusColor)" }}
        />
        <ModalBody p="24px 48px">{previewMap(currentStep)}</ModalBody>

        <ModalFooter justifyContent="center" pb="30px" gridGap="14px">
          <Button
            minW="120px"
            disabled={isLoading}
            onClick={onClose}
            bg="transparent"
            border="2px solid transparent"
            color="#03A438"
          >
            Close
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default CardTransactionDetail;
